<template>
  <div
    class="com-item"
    v-if="type == 'preview'"
    :key="index"
  >
    <div class="component person-nav coursePage">
      <div
        class="van-sticky"
        v-if="modata.WContent.nav && modata.WContent.nav.length > 0"
        :style="{ padding: '0 ' + (modata.WContent.moduleSpac*proportion || 0) + 'px' }"
      >
        <div class="course-title">{{ modata.WContent.moduleTitle }}</div>
        <div class="course-describe">{{ modata.WContent.moduleDescribe }}</div>

        <div
          style="position: relative"
          v-if="modata.WContent.moduleType == 1 || !modata.WContent.moduleType"
        >
          <div class="course-wrap" @mousedown="startDrag" @mouseleave.self="stopDrag" @mouseup="stopDrag" ref="courseClient">
            <div class="course-scroll" :style="{ transform: `translateX(${currentTranslateX}px)`,transition:downStatus?'none':'transform 0.5s ease-in-out' }" ref="courseScroll" >
              <!-- 样式1 -->
              <div
                ref="courseView"
                style="display: inline-block"
                v-if="
                  modata.WContent.moduleType == 1 || !modata.WContent.moduleType
                "
              >
                <div class="course-list course-list_odd">
                  <template v-for="(item, index) in modata.WContent.nav">
                    <div class="item" :key="index" v-if="index % 2 == 0" :ref="'item_'+index">
                      <div class="column flex1" :style="item.offsetSeat|setopacity(currentTranslateX,clientWidth,itemCliWidth)">
                        <el-image
                          class="img"
                          :src="item.ImgUrl"
                          :preview-src-list="[item.ImgUrl]"
                          fit="contain"
                        ></el-image>
                        <div class="describe" v-html="item.describe"></div>
                        <div class="title">{{ item.title }}</div>
                      </div>
                      
                      <div class="speedIcon">
                        <div
                          class="line1"
                          :style="{ opacity: index == 0 ? 0 : 1 }"
                        ></div>
                        <div class="circular"></div>
                        <div
                          class="line2"
                          :style="{
                            opacity:
                              modata.WContent.nav.length == index + 1 ? 0 : 1,
                          }"
                        ></div>
                      </div>
                    </div>
                    <div
                      class="column alone-speed"
                      :key="'circular_' + index"
                       :ref="'circular_'+index"
                      v-else
                    >
                      <div class="empty"></div>
                      <div class="speedIcon">
                        <div class="circular"></div>
                      </div>
                    </div>
                  </template>
                </div>
                <div class="course-list course-list_enev">
                  <template v-for="(item, index) in modata.WContent.nav">
                    <div
                      class="column alone-speed"
                      :key="'circular_' + index"
                      v-if="index % 2 == 0"
                    >
                      <div class="empty"></div>
                    </div>

                    <div class="item" :key="index" :ref="'item_'+index" :style="item.offsetSeat|setopacity(currentTranslateX,clientWidth,itemCliWidth)" v-else>
                      <div class="title">{{ item.title }}</div>
                      <div class="describe">{{ item.describe }}</div>
                      <el-image
                        class="img"
                        :src="item.ImgUrl"
                        :preview-src-list="[item.ImgUrl]"
                        fit="contain"
                      ></el-image>
                    </div>
                  </template>
                </div>
              </div>
              <!-- 样式2 -->
              <!-- <div style="display: inline-block" v-else>
              <div class="course-list-2">
                <div
                  class="item"
                  :ref="'item_' + index"
                  :key="index"
                  v-for="(item, index) in modata.WContent.nav"
                >
                  <div class="imgWrap">
                    <el-image
                      class="img"
                      :src="item.ImgUrl"
                      :preview-src-list="[item.ImgUrl]"
                    ></el-image>
                  </div>
                  <div class="describe" v-html="item.describe"></div>
                </div>
              </div>
            </div> -->
            </div>
          </div>
        <template v-if="scrollWidth>0">
          <div class="arrow-speed_icon arrow-speed_left" @click="prevSlide" @mousedown="clearTime" @mouseup="slideTimeOper" :style="{ left: (modata.WContent.navigationSpac*proportion || 0) + 'px' }">
              <i class="el-icon-arrow-left"></i>
            </div>
            <div class="arrow-speed_icon arrow-speed_right" @click="nextSlide" @mousedown="clearTime" @mouseup="slideTimeOper" :style="{ right: (modata.WContent.navigationSpac*proportion || 0) + 'px' }">
              <i class="el-icon-arrow-right"></i>
            </div>
 
        </template>
        </div>

        <!-- 新 -->
        <div v-else-if="swiperOption" class="mySwiper-wrap">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide
              v-for="(item, index) in modata.WContent.nav"
              
              :key="index"
            >
              <div class="course-list-2">
                <div class="item" :ref="'item_' + index">
                  <div class="imgWrap">
                    <el-image
                      class="img"
                      :src="item.ImgUrl"
                      :preview-src-list="[item.ImgUrl]"
                       :style="{height:(modata.WContent.imgHeight||160)+'px',}"
                    ></el-image>
                  </div>
                  <div class="describe" v-html="item.describe"></div>
                </div>
              </div>
            </swiper-slide>
            <!-- <div class="swiper-button-prev" slot="button-prev" style="">
                <i class="el-icon-arrow-left"></i>
              </div>
              <div class="swiper-button-next " slot="button-next">
                <i class="el-icon-arrow-right"></i>
              </div> -->
          </swiper>
          <div
            class="arrow-speed_icon arrow-speed_left"
            :style="{ left: (modata.WContent.navigationSpac*proportion || 0) + 'px' }"
            @click="handPrev"
          >
            <i class="el-icon-arrow-left"></i>
          </div>
          <div
            class="arrow-speed_icon arrow-speed_right"
            :style="{ right: (modata.WContent.navigationSpac*proportion || 0) + 'px' }"
              @click="handNext"
          >
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "course-module",
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    type: {
      //展示类型 preview预览模块 setting设置模块
      type: String,
      default: "preview",
    },
   phoneWidth: {
      type: Number,
      default: 1280,
    },
    proportion: {
        type: Number,
        default:1,
    },
    index: {
      //索引
      type: Number,
    },
    predefineColors: {
      type: Array,
    },
    modata: {
      type: Object,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function () {
        return {
          WName: "course",
          Title: "历程模块",
          WID: 1,
          ModuleName: "course-module",
          WContent: {},
        };
      },
    },
  },
  data() {
    return {
      swiperOption:null,

      currentIndex: 0,  
      isDragging: false,  
      startX: 0,  
      currentTranslateX: 0,  
      itemWidth: 0,  
      itemCliWidth:0,
      clientWidth:0,
      time:"",
      downStatus:false,
      scrollWidth:0,


    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper?this.$refs.mySwiper.swiper:null;
    },
  },
  mounted() {

    let swiperOption = {
      slidesPerView:"auto",
      spaceBetween: 20,
      autoplay: {
        delay: 5000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      observer: true,
      observeParents: true,
      
     breakpoints: { 
      200: {  //当屏幕宽度大于等于
        slidesPerView: 1,
        spaceBetween: 0
      },
      400: {  //当屏幕宽度大于等于
        slidesPerView:"auto",
        spaceBetween: 10
      },
      980: {  //当屏幕宽度大于等于
        spaceBetween: 20
      },
      1580: {
        spaceBetween: 30
      },
    }
      
    //   slidesPerView: 3,
    //   breakpoints: { 
    //   200: {  //当屏幕宽度大于等于
    //     slidesPerView: 1,
    //     spaceBetween: 0
    //   },
    //   600: {  //当屏幕宽度大于等于
    //     slidesPerView: 2,
    //     spaceBetween: 10
    //   },
    //   980: {  //当屏幕宽度大于等于
    //     slidesPerView: 3,
    //     spaceBetween: 20
    //   },
    //   1280: {   
    //     slidesPerView: 4,
    //     spaceBetween: 20
    //   },
    //   1580: {
    //     slidesPerView: 5,
    //     spaceBetween: 30
    //   },
    //   1980: {
    //     slidesPerView: 6,
    //     spaceBetween: 30
    //   },

    //   3980: {
    //     slidesPerView: 6,
    //     spaceBetween: 30
    //   }
    // }
    };
    let WContent = this.modata.WContent;
    if (WContent.AutoChangState) {
      swiperOption.autoplay.delay = (WContent.AutoChangeSec || 5) * 1000;
    } else {
      swiperOption.autoplay = false;
    }
    this.swiperOption = swiperOption;

    this.$nextTick(() => {  
      if(WContent.moduleType == 1 || !WContent.moduleType){
        this.itemCliWidth=this.$refs['item_0'][0].clientWidth;
        this.itemWidth = this.$refs['item_0'][0].clientWidth+this.$refs['circular_1'][0].clientWidth;//this.$el.querySelector('.carousel-item').clientWidth;  
        let clientWidth=this.$refs.courseClient.clientWidth;
        this.clientWidth=clientWidth;
        WContent.nav.forEach((item,index)=>{
        item.offsetSeat=this.$refs["item_"+index][0].offsetLeft;
        })

        this.slideTimeOper();
        this.scrollWidth=this.$refs.courseView.clientWidth-clientWidth;
      }
      
      }); 



  },
  beforeDestroy() {},
  methods: {

    //轮播进度
     handPrev() {
      this.swiper.slidePrev();
    },
    handNext() {
      this.swiper.slideNext();
    },


   //原生轮播
  //  <button @click="prevSlide" class="carousel-button prev">Prev</button>  
  //   <button @click="nextSlide" class="carousel-button next">Next</button> 
    startDrag(e) {
      if(this.scrollWidth<=0){
        return
      }
   
      this.isDragging = true;  
      this.startX = e.clientX - this.currentTranslateX;  
      this.$refs.courseClient.addEventListener('mousemove', this.onDrag);  
      this.$refs.courseClient.addEventListener('mouseup', this.stopDrag);  
      this.downStatus=true;
      this.clearTime();
      e.stopPropagation();
      e.preventDefault();
    },  
    onDrag(e) {  
      if (!this.isDragging) return;  
      this.currentTranslateX = e.clientX - this.startX;  
      this.rebound();  
    },  
    stopDrag() {  
      this.isDragging = false;  
      this.$refs.courseClient.removeEventListener('mousemove', this.onDrag);  
      this.$refs.courseClient.removeEventListener('mouseup', this.stopDrag);  
      this.downStatus=false;
      this.slideTimeOper();
      this.snapToItem();  
    },  
   rebound() {  
      // const totalItems = this.modata.WContent.nav.length/2;
      // const maxTranslateX = -(totalItems - 1) * this.itemWidth;  
      const maxTranslateX =-this.scrollWidth;
      if (this.currentTranslateX > 0) {  
        this.currentTranslateX = 0;  
      } else if (this.currentTranslateX < maxTranslateX) {  
        this.currentTranslateX = maxTranslateX;  
      }  
    },  
    snapToItem() {  
      const targetIndex = Math.round(-this.currentTranslateX / this.itemWidth);  
      // this.currentIndex = targetIndex;  
      if(Math.abs(this.currentTranslateX)>=this.scrollWidth){
         this.currentTranslateX = -this.scrollWidth;  
      }else{
        this.currentTranslateX = -targetIndex * this.itemWidth;  
      }
     
    },  


    nextSlide() {
      let scrollWidth=this.scrollWidth;
      let currentTranslateX=this.currentTranslateX-this.itemWidth;
      if(Math.abs(currentTranslateX)>scrollWidth){
        currentTranslateX=-scrollWidth;
      }
     this.currentTranslateX = currentTranslateX;  
    },  
    prevSlide() {  
      let currentTranslateX=this.currentTranslateX+this.itemWidth;
      if(currentTranslateX>0){
        currentTranslateX=0;
      }
       this.currentTranslateX =currentTranslateX
    },  
   

   slideTimeOper(){
    this.clearTime();
    if(this.modata.WContent.AutoChangState){
      this.time=setInterval(()=>{
        this.nextSlide();
      },(this.modata.WContent.AutoChangeSec*1000)||3000)
    }
 
   },
   clearTime(){
      if(this.time){
        clearInterval(this.time);
        this.time=null;
      }
   },

   //end
  },
  watch: {
 
  },

  filters: {
      setopacity(offsetSeat,currentTranslateX,clientWidth,itemCliWidth){
        return {opacity:clientWidth-offsetSeat-itemCliWidth-currentTranslateX>=-5 && offsetSeat>=Math.abs(currentTranslateX)?1:0}
      },
       



   },

};
</script>
<style lang="scss" scoped>
.el-card-box {
  margin-bottom: 16px;
}

// 显示
.column {
  display: flex;
  flex-direction: column;
}

.van-sticky {
  text-align: center;
}
.course-title {
  font-size: 22px;
  font-weight: 700;
  text-align: center;
  padding-top: 30px;
}
.course-describe {
  font-size: 15px;
  margin-top: 6px;
  margin-bottom: 5px;
}
.course-wrap{
  padding: 20px 0;
  overflow: hidden;
}
.course-scroll {
  //   
  // overflow-y: auto;
  // padding: 20px 4px;
}
.course-transition{
 transition: transform 0.5s ease-in-out; 
}


/* 设置滚动条的宽度和颜色 */
.course-scroll::-webkit-scrollbar {
  height: 5px;
  background-color: #f5f5f5;
}

/* 设置滚动条滑块的样式 */
.course-scroll::-webkit-scrollbar-thumb {
  background-color: #888;
}

/* 设置滚动条滑块的hover状态样式 */
.course-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

.course-list {
  display: flex;
  flex-direction: row;
  font-size: 14px;
  .item {
    display: flex;
    flex-direction: column;
    width: 180px;
    flex: none;
  }
  .img {
    width: 96%;
    height: auto;
    margin-bottom: 12px;
    margin-left: 2%;
    flex: none;
  }
  .describe {
    margin-bottom: 12px;
    flex: 1;
    white-space: pre-wrap; /* 保留空白符号，但是文本会自动换行 */
    word-break: break-all; /* 允许在单词内换行 */
  }
  .title {
    font-size: 22px;
    font-weight: 700;
    flex: none;
  }

  .speedIcon {
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 20px 0;
    flex: none;

    .line1,
    .line2 {
      flex: 1;
      height: 3px;
      background-color: #333;
    }
    .circular {
      width: 20px;
      height: 20px;
      background-color: #333;
      border-radius: 20px;
      margin: 0 12px;
      flex: none;
    }
  }
}

.course-list_enev {
  .title {
    margin-bottom: 12px;
  }
  .alone-speed:first-child .empty {
    width: 112px; //加上第一个的一半
  }
}

.alone-speed {
  .empty {
    width: 44px;
    flex: 1;
  }
}

// 样式2
.course-list-2 {
  display: flex;
  flex-direction: row;
  font-size: 14px;
  .item {
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: none;

  }
  .item + .item {
    margin-left: 20px;
  }
  .imgWrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 2;
    width: min-content;
  }
  .img {
    // width: 100%;
    height: auto;
    flex: none;
  }
  img{
    width: auto;
  }
  .describe {
    margin-top: 12px;
    white-space: pre-wrap; /* 保留空白符号，但是文本会自动换行 */
    word-break: break-all; /* 允许在单词内换行 */
  }
}

// 按钮
.arrow-speed_icon {
  width: 40px;
  height: 40px;
  border-radius: 32px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  text-align: center;
  line-height: 40px;
  font-size: 20px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9;
  cursor: pointer;
}
.arrow-speed_left {
  left: 10px;
}
.arrow-speed_right {
  right: 10px;
}


</style>


<style lang="scss">
.course-list-2 img{
    width: auto;
  }

.coursePage{
   .swiper-slide{
    width: auto;
  }
}

@media (max-width: 400px) {
  .coursePage{
   .swiper-slide{
    width: 100%;
  }
  .item{
    align-items: center;
  }
}
}

 
</style>

